import React, { memo, useEffect } from "react";
import { Handle, Position } from "@xyflow/react";
import { NarrativeTitle } from "@src/pages/intelligence-search-v2/components/json-query/result/auto-generated-title";
import { useAnalyzeQuery } from "../../hooks/use-analyze-query";
import { Card } from "antd";

export default memo(
    ({
        data,
        isConnectable = true,
        sourcePosition,
        targetPosition,
    }: {
        data: any;
        isConnectable?: boolean;
        sourcePosition?: Position;
        targetPosition?: Position;
    }) => {
        const { queryName, productCode, jsonQuery } = data;
        // const [nodeContent, setNodeContent] = React.useState<React.Component>(questionName)
        const [nodeContent, setNodeContent] = React.useState<any>(<></>);
        const { meta, isLoading, isError, refetch } = useAnalyzeQuery({
            productCode,
            jsonQuery,
            shouldFetchData: false,
        });

        useEffect(() => {
            if (productCode && jsonQuery) {
                refetch();
            }
        }, [productCode, jsonQuery, refetch]);

        useEffect(() => {
            if (meta) {
                setNodeContent(<NarrativeTitle jsonQuery={jsonQuery} referencedAssets={meta} />);
            }
        }, [jsonQuery, meta, setNodeContent]);

        return (
            <div>
                <Card title={queryName} className="bg-red">
                    {nodeContent}
                </Card>
                {sourcePosition ? (
                    <Handle
                        type="source"
                        position={sourcePosition}
                        // onConnect={(params) => console.log('handle onConnect', params)}
                        isConnectable={isConnectable}
                    />
                ) : null}

                {targetPosition ? (
                    <Handle
                        type="target"
                        position={targetPosition}
                        // onConnect={(params) => console.log('handle onConnect', params)}
                        isConnectable={isConnectable}
                    />
                ) : null}
                {/* 
      <Handle
        type="target"
        position={Position.Left}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={isConnectable}
      /> */}

                {/* <div>
        Custom Color Picker Node: <strong>{data.color}</strong>
      </div>
      <input
        className="nodrag"
        type="color"
        onChange={data.onChange}
        defaultValue={data.color}
      /> */}
                {/* <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
      /> */}
            </div>
        );
    },
);
